exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".holdcourt-all-btn[data-v-f84c592c]{margin-left:20px;margin-top:20px}.holdcourt-table[data-v-f84c592c]{margin-top:40px}.holdcourtLot .tipCount[data-v-f84c592c],.holdcourt .tipCount[data-v-f84c592c]{margin:20px 0}.holdcourtLot .holdcourtLot-add[data-v-f84c592c],.holdcourt .holdcourtLot-add[data-v-f84c592c]{position:absolute;left:70%;top:0;font-size:25px}\n", ""]);

// exports
